module.exports = __webpack_public_path__ + "img/logo_sk_ru_black.471eaf1d.png";